export const legalContent = {
  fr: {
    mentions: {
      overline: "Informations légales",
      title: "Mentions légales",
      updated: "Dernière mise à jour : septembre 2026",
      sections: [
        {
          heading: "Éditeur du site",
          body: "Le site oris-international.com est édité par ORIS INTERNATIONAL, société de négoce international de matières premières agricoles et de produits surgelés. Bureaux : Marcory Résidentiel, 22 rues Cérès, Abidjan, Côte d'Ivoire — et 1 rue Jacqueline Auriol, 13700 Marignane, France. Téléphone : +225 07 10 35 16 17 / +33 7 75 05 74 07. Email : contact@oris-international.com.",
        },
        {
          heading: "Directeur de la publication",
          body: "Le directeur de la publication est la direction générale d'ORIS INTERNATIONAL.",
        },
        {
          heading: "Hébergement",
          body: "Le site est hébergé sur la plateforme Emergent (emergent.sh). L'hébergeur assure la disponibilité technique de l'infrastructure ; l'éditeur reste responsable des contenus publiés.",
        },
        {
          heading: "Propriété intellectuelle",
          body: "L'ensemble des contenus du site (textes, logo, emblème, photographies, éléments graphiques) est la propriété d'ORIS INTERNATIONAL ou de ses partenaires. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.",
        },
        {
          heading: "Limitation de responsabilité",
          body: "Les informations présentées sur ce site (produits, spécifications, conditionnements) sont fournies à titre indicatif. Elles n'ont valeur contractuelle qu'après confirmation écrite dans le cadre d'une offre ou d'un contrat de vente. ORIS INTERNATIONAL ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site.",
        },
        {
          heading: "Services tiers",
          body: "La carte de localisation est fournie par Google Maps ; son utilisation est soumise aux conditions de Google. Le formulaire de contact est traité selon les modalités décrites dans notre Politique de confidentialité.",
        },
      ],
    },
    privacy: {
      overline: "Protection des données",
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : septembre 2026",
      sections: [
        {
          heading: "Données collectées",
          body: "Via le formulaire de contact, nous collectons uniquement : votre nom, le nom de votre société (facultatif), votre adresse email, le sujet et le contenu de votre message. Aucune autre donnée personnelle n'est collectée.",
        },
        {
          heading: "Finalité du traitement",
          body: "Ces données servent exclusivement à répondre à vos demandes (cotation, approvisionnement, partenariat) et à gérer la relation commerciale qui en découle. Elles ne sont jamais utilisées à des fins publicitaires ni cédées à des tiers.",
        },
        {
          heading: "Base légale",
          body: "Le traitement repose sur l'exécution de mesures précontractuelles prises à votre demande et sur l'intérêt légitime d'ORIS INTERNATIONAL à répondre aux sollicitations commerciales.",
        },
        {
          heading: "Durée de conservation",
          body: "Les messages sont conservés au maximum 24 mois, puis supprimés, sauf si une relation contractuelle impose une conservation plus longue.",
        },
        {
          heading: "Destinataires et sous-traitants",
          body: "Vos données sont accessibles uniquement à l'équipe d'ORIS INTERNATIONAL. Une notification email technique est envoyée via un prestataire d'envoi d'emails, qui traite le contenu du message pour la seule finalité de transmission.",
        },
        {
          heading: "Vos droits",
          body: "Conformément au RGPD et aux lois applicables, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition concernant vos données. Pour l'exercer, écrivez à contact@oris-international.com ; nous répondons sous 30 jours.",
        },
        {
          heading: "Cookies",
          body: "Le site ne dépose aucun cookie publicitaire ni de ciblage. Des mesures d'audience techniques et anonymisées peuvent être collectées par la plateforme d'hébergement à des fins de statistiques.",
        },
        {
          heading: "Sécurité",
          body: "Nous appliquons des mesures techniques et organisationnelles appropriées : accès restreint aux messages, connexions chiffrées (HTTPS) et espace d'administration protégé par mot de passe.",
        },
      ],
    },
  },
  en: {
    mentions: {
      overline: "Legal information",
      title: "Legal notice",
      updated: "Last updated: September 2026",
      sections: [
        {
          heading: "Site publisher",
          body: "The oris-international.com website is published by ORIS INTERNATIONAL, an international trading company for agricultural raw materials and frozen products. Offices: Marcory Résidentiel, 22 rues Cérès, Abidjan, Côte d'Ivoire — and 1 rue Jacqueline Auriol, 13700 Marignane, France. Phone: +225 07 10 35 16 17 / +33 7 75 05 74 07. Email: contact@oris-international.com.",
        },
        {
          heading: "Publication director",
          body: "The publication director is the general management of ORIS INTERNATIONAL.",
        },
        {
          heading: "Hosting",
          body: "The site is hosted on the Emergent platform (emergent.sh). The host is responsible for infrastructure availability; the publisher remains responsible for published content.",
        },
        {
          heading: "Intellectual property",
          body: "All site content (texts, logo, emblem, photographs, graphic elements) is the property of ORIS INTERNATIONAL or its partners. Any reproduction, representation or distribution, in whole or in part, without prior written authorization is prohibited.",
        },
        {
          heading: "Limitation of liability",
          body: "Information on this site (products, specifications, packaging) is provided for guidance only. It is contractually binding only after written confirmation within an offer or sales contract. ORIS INTERNATIONAL shall not be held liable for direct or indirect damages resulting from the use of the site.",
        },
        {
          heading: "Third-party services",
          body: "The location map is provided by Google Maps; its use is subject to Google's terms. The contact form is processed as described in our Privacy Policy.",
        },
      ],
    },
    privacy: {
      overline: "Data protection",
      title: "Privacy policy",
      updated: "Last updated: September 2026",
      sections: [
        {
          heading: "Data collected",
          body: "Through the contact form we collect only: your name, company name (optional), email address, and the subject and content of your message. No other personal data is collected.",
        },
        {
          heading: "Purpose",
          body: "This data is used exclusively to answer your requests (quotation, sourcing, partnership) and to manage the resulting business relationship. It is never used for advertising or shared with third parties.",
        },
        {
          heading: "Legal basis",
          body: "Processing is based on pre-contractual measures taken at your request and on ORIS INTERNATIONAL's legitimate interest in responding to business enquiries.",
        },
        {
          heading: "Retention period",
          body: "Messages are kept for a maximum of 24 months, then deleted, unless a contractual relationship requires longer retention.",
        },
        {
          heading: "Recipients and processors",
          body: "Your data is accessible only to the ORIS INTERNATIONAL team. A technical email notification is sent through an email delivery provider, which processes the message content solely for transmission purposes.",
        },
        {
          heading: "Your rights",
          body: "Under GDPR and applicable laws, you have rights of access, rectification, erasure, restriction and objection regarding your data. To exercise them, write to contact@oris-international.com; we respond within 30 days.",
        },
        {
          heading: "Cookies",
          body: "The site sets no advertising or targeting cookies. Technical, anonymized audience measurement may be collected by the hosting platform for statistics.",
        },
        {
          heading: "Security",
          body: "We apply appropriate technical and organizational measures: restricted access to messages, encrypted connections (HTTPS) and a password-protected administration area.",
        },
      ],
    },
  },
};
